<template>
    <v-snackbar @click="show = false" class="footerSpace" v-model="show" :timeout="timeout" :color="type">
        {{ message}}
    </v-snackbar>
</template>

<script>
export default {
    data (){
        return {
            message: '',
            show: false,
            type: 'error',
            timeout: 10000,
        }
    },
    created() {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type == 'setSnack') {
                if (state.snack.type== 'error')
                {
                    if (state.snack.msg.response != undefined)
                    {
                        const msg = state.snack.msg.response
                        if ( msg !== ''){
                            var messageAPI = ''
                            if (msg.responseText != "")
                            {
                                msg.data.forEach(function (errorItem) {
                                    if (messageAPI == '')
                                    {
                                        messageAPI = messageAPI + errorItem.value
                                    }   
                                    else
                                    {
                                        messageAPI = messageAPI + '<br>' + errorItem.value
                                    }
                                })
                            }
                            this.message = messageAPI
                        }
                    }
                    else 
                    {
                        this.message = state.snack.msg
                    }                        
                    this.type = state.snack.type
                    this.show = true
                    this.timeout = 10000
                }
                else
                {
                    this.message = state.snack.msg
                    this.type = state.snack.type
                    this.show = true
                    this.timeout = 5000
                }
            }
        })
    }
}
</script>

<style scoped>
    .footerSpace{
        bottom: 35px;
    }
</style>
